var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "send-list-form",
    _vm._b(
      {
        attrs: { mode: _vm.mode },
        on: { created: _vm.onCreated, updated: _vm.onUpdated },
      },
      "send-list-form",
      _vm.formData,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }